<template lang="pug">
div
  v-layout.mt-4(align-center, v-if='!isNew')
    span(style='width: 240px') Product Afbeelding

    text-field.mr-0(
      :value='lease.productImage',
      hide-details,
      :disabled='true',
      :readonly='true'
      )
    v-tooltip(top)
      v-btn.ma-0.ml-2(icon, slot='activator', :href='lease.productImage', target='_blank')
        v-icon fa fa-external-link-alt
      span Bekijken

  v-layout.mt-4(align-center, v-if='!isNew')
    span(style='width: 240px') Herkomst URL

    text-field.mr-0(
      :value='lease.productUrl',
      hide-details,
      :disabled='true',
      :readonly='true'
      )
    v-tooltip(top)
      v-btn.ma-0.ml-2(icon, slot='activator', :href='lease.originUrl', target='_blank')
        v-icon fa fa-external-link-alt
      span Bezoeken
</template>

<script>

export default {
  data () {
    return {
      lease: {}
    }
  },

  computed: {
    isNew () {
      return this.$route.params.leaseId.includes('nieuwe-')
    }
  },

  async created () {
    if (!this.isNew) {
      this.lease = await this.$store.dispatch('graphqlQuery', {
        name: 'getLease',
        variables: {
          id: this.$route.params.leaseId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
